import { useGetChildCareUrlQuery } from 'redux/apiSlice/events.slice';
import CopyUrls from '../CopyUrls';
import { TCopyChildCareUrlProps } from './CopyChildCareUrl.types';

const CopyChildCareUrl = ({ eventId, copyText }: TCopyChildCareUrlProps) => {
  const { data: childCareUrl } = useGetChildCareUrlQuery(
    {
      eventId,
    },
    {
      skip: !eventId,
    },
  );

  return <CopyUrls copyText={copyText} copyUrl={childCareUrl} />;
};

export default CopyChildCareUrl;
